import { render, staticRenderFns } from "./AppLayoutWelcome.vue?vue&type=template&id=61e0ea24&scoped=true&"
import script from "./AppLayoutWelcome.vue?vue&type=script&lang=js&"
export * from "./AppLayoutWelcome.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutWelcome.vue?vue&type=style&index=0&id=61e0ea24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0ea24",
  null
  
)

export default component.exports